import Model from "../Model";
import tw from "tailwind-styled-components";
import {
    SideCancelBtn,
    DeleteBtn
} from "../Styles/InputStyles";

const DeleteModal = ({
    isOpen,
    setOpenModel,
    title = "Confirm Deletion",
    message = "Are you sure you want to delete this item?",
    loading = false,
    onDelete,
    onClose,
    deleteBtnText = "Delete",
    cancelBtnText = "Cancel",
}) => {

    if (!isOpen) return null;

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setOpenModel}
            title={title}
        >

            <WarningText>
                {message}
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4 mt-8">

                <SideCancelBtn
                    type="button"
                    onClick={onClose}
                >
                    {cancelBtnText}
                </SideCancelBtn>

                <DeleteBtn
                    onClick={onDelete}
                    disabled={loading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {loading ? "Deleting..." : deleteBtnText}
                </DeleteBtn>

            </div>

        </Model>
    );
};

const WarningText = tw.p`
    text-gray-500 text-base mb-4
`;

export default DeleteModal;